import { useState } from 'react'
import { mutations } from '../../resources'
import { useDispatch } from '../redux'
import { NotificationPreferenceModel } from '../../models'
import { NotificationsPreferenceUpdateRequest } from '../../resources/auth/types'
import { actions } from '../../store'
import { generateError } from '../../helpers/errors'

export const useNotificationsPreferenceUpdate = () => {
    const dispatch = useDispatch()
    const [inProgress, setInProgress] = useState(false)

    const updateNotificationsPreference = (
        payload: NotificationsPreferenceUpdateRequest,
    ): Promise<NotificationPreferenceModel> => {
        setInProgress(true)
        return mutations
            .updateNotificationsPreference(payload)
            .then(({ data }) => {
                setInProgress(false)
                if (data) {
                    dispatch(actions.updateNotificationPreferences(data))
                    return data
                }
                throw generateError()
            })
            .catch((error) => {
                setInProgress(false)
                throw generateError(error)
            })
    }

    return {
        updateNotificationsPreference,
        inProgress,
    }
}
